/**
 * Forces an ID token refresh, republishes session (so custom claims update in context),
 * then clears users/{uid}.needsPermissionsRefresh.
 *
 * @param {{
 *   firebaseUser: import('firebase/auth').User,
 *   userRef: import('firebase/firestore').DocumentReference,
 *   updateDoc: typeof import('firebase/firestore').updateDoc,
 *   publishUserSession: (
 *     user: import('firebase/auth').User | null,
 *     callback: (state: object) => void,
 *   ) => Promise<unknown>,
 *   sessionCallback: (state: object) => void,
 * }} params
 */
export async function applyNeedsPermissionsRefresh({
  firebaseUser,
  userRef,
  updateDoc,
  publishUserSession,
  sessionCallback,
}) {
  await firebaseUser.getIdToken(true);
  await publishUserSession(firebaseUser, sessionCallback);
  await updateDoc(userRef, { needsPermissionsRefresh: false });
}
